<template>
    <div class="vacancy-detail container">
        <div class="vacancy-detail__container">
            <z-link
                class="vacancy-detail__link"
                size="m"
                iconPosition="left"
                icon="arrow"
                :href="nav['back-link']"
                >{{ text.linkText }}</z-link
            >
        </div>

        <section>
            <div class="vacancy-detail__hero">
                <div class="vacancy-detail__hero-item-container">
                    <div v-if="vacancyData.money && vacancyData.money.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p" >{{ text.money }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">{{ vacancyData.money.value }}</z-caption>
                    </div>

                     <div v-if="vacancyData.city && vacancyData.city.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p" >{{ text.filters.city }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">{{ vacancyData.city.value }}</z-caption>
                    </div>

                    <div v-if="vacancyData.type && vacancyData.type.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p">{{ text.filters.jobType }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">{{ vacancyData.type.value }}</z-caption>
                    </div>

                    <div v-if="vacancyData.specialization && vacancyData.specialization.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p">{{ text.filters.specialization }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">{{ vacancyData.specialization.value }}</z-caption>
                    </div>
                </div>

                <div class="vacancy-detail__hero-action-container">
                    <a class="vacancy-detail__hero-link" :href="`/${$root.lang}/career/seekers?position=${vacancyData.name}&id=${vacancyData.hfid.value}`">
                        <z-button class="vacancy-detail__hero-action-button">Откликнуться на вакансию
                            <template v-slot:right>
                                <z-icon
                                    name="arrow_long"
                                    dir="right"
                                    width="32"
                                    height="20"
                                ></z-icon>
                            </template>
                        </z-button>
                    </a>
                    <!--
                    <a class="vacancy-detail__hero-link" href="#">
                        <z-button kind="secondary" class="vacancy-detail__hero-action-button">Откликнуться на hh.ru
                            <template v-slot:right>
                                <z-icon
                                    name="arrow_long"
                                    dir="right"
                                    width="32"
                                    height="20"
                                ></z-icon>
                            </template>
                        </z-button>
                    </a>
                     -->
                </div>
            </div>

            <div class="vacancy-detail__detail" v-if="vacancyData.responsibilities && vacancyData.responsibilities.value">
                <z-caption class="vacancy-detail__detail-title" tag="h2">Обязанности</z-caption>

                <vue-raw class="html-content" :raw="vacancyData.responsibilities.value" />
            </div>

            <div class="vacancy-detail__detail" v-if="vacancyData.requirements && vacancyData.requirements.value">

                <z-caption class="vacancy-detail__detail-title" tag="h2">Требования</z-caption>
                <vue-raw class="html-content" :raw="vacancyData.requirements.value" />
            </div>

            <div class="vacancy-detail__detail" v-if="vacancyData.conditions && vacancyData.conditions.value">

                <z-caption class="vacancy-detail__detail-title" tag="h2">Условия</z-caption>
                <vue-raw class="html-content" :raw="vacancyData.conditions.value" />
            </div>

            <div class="vacancy-detail__hero" v-if="(vacancyData.request_email && vacancyData.request_email.value) || (vacancyData.request_phone && vacancyData.request_phone.value)">
                <div class="vacancy-detail__hero-item-container">
                    <div v-if="vacancyData.request_email && vacancyData.request_email.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p" >{{ text.recuter_email }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">
                            <z-link class="communication-item__link" :href="`mailto:${vacancyData.request_email.value}`" :inline="false" icon="mail" icon-width="20" icon-height="20">
                                {{ vacancyData.request_email.value }}
                            </z-link>
                        </z-caption>
                    </div>

                    <div v-if="vacancyData.request_phone && vacancyData.request_phone.value" class="vacancy-detail__hero-item">
                        <z-caption class="vacancy-detail__hero-title" tag="p">{{ text.recuter_phone }}</z-caption>
                        <z-caption class="vacancy-detail__hero-text" tag="p">
                            <z-link class="communication-item__link" :href="`tel:${vacancyData.request_phone.phone}`" icon="phone" icon-width="20" icon-height="20">
                                {{ vacancyData.request_phone.value }}
                            </z-link>
                       </z-caption>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { text } from './constans'

export default {
    name: 'vacancy-detail-page',
    data () {
        return {
            vacancyData: {},
            nav: {},
            text
        }
    },
    mounted () {
        this.vacancyData = this.$root.app.components['vacancies-detail'].item
        this.nav = this.$root.app.components['vacancies-detail'].nav
        this.SetHeroTitle(this.vacancyData.name)
    },
    methods: {
        ...mapActions(['SetHeroTitle'])
    }
}
</script>

<style lang="scss">
.vacancy-detail {
    margin-bottom: 90px;

    &__container {
        display: flex;
        justify-content: space-between;
        margin-bottom: $token-spacers-m;

        @media screen and(max-width: 480px) {
            flex-wrap: wrap;
        }
    }

    &__hero {
        padding: $token-spacers-m;
        background-color: $token-colors-secondary-bg;
        margin-bottom: $token-spacers-m;

        &-item-container {
            margin-bottom: $token-spacers-s;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        &-item {
            margin-right: $token-spacers-s;
            margin-bottom: 12px;
        }

        &-title {
            font-weight: 500 !important;
            font-size: 16px !important;
            line-height: 140% !important;
            color: $token-colors-black-40 !important;
            margin-bottom: 4px !important;
        }

        &-text {
            font-weight: 500 !important;
            font-size: 16px !important;
            line-height: 140% !important;
            color: $token-colors-black-80 !important;
        }

        &-link {
            text-decoration: none;
        }

        &-action-container {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
        }

        &-action-button {
            &:first-child {
             margin-right: $token-spacers-s;
            }

            font-size: 20px !important;
            line-height: 27px !important;
            margin-bottom: 12px;

            @include breakpoint(tablet) {
                font-size: 18px !important;
            }

             @include breakpoint(mobile) {
                font-size: 16px !important;
            }
         }
    }

    &__detail {
        &:not(:last-child) {
            margin-bottom: $token-spacers-l;
        }

        &-title {
            font-family: 'FranklinGothicITC';
            font-size: 30px !important;
            line-height: 150% !important;
            color: $token-colors-black-80 !important;
            margin-bottom: $token-spacers-xs !important;

            @include breakpoint(tablet) {
                font-size: 28px !important;
            }

             @include breakpoint(mobile) {
                font-size: 24px !important;
            }
        }
    }

    &__link {
        color: #15386c;
        margin-right: 10px;
        font-weight: 600;
        font-size: 20px !important;
        line-height: 27px !important;
        display: flex !important;
        align-items: center !important;

        @media screen and(max-width: 480px) {
            margin-bottom: 12px;
        }

        .z-icon {
            transform: rotate(-90deg) !important;
        }
    }
}
</style>
